import * as React from 'react';
import { Icon, Text } from '@doordash/design-language';

import { CartIconWrapper, IconWrapper, StepperIconWrapper, StepperWrapper } from './recommendationStyles';

interface QuantityStepperProps {
  quantity: number;
  onIncrement: () => void;
  // Called when quantity > 1 and user taps the minus icon.
  onDecrement: () => void;
  // Called when quantity === 1 and user taps the trash icon (i.e. removes the item).
  onRemove: () => void;
  // Reserves cart-icon-style padding around the stepper. Match the calling
  // context — true inside a cart row, false in floating menu-item editors.
  adjustPadding?: boolean;
}

// Pure presentational stepper shared by the standard cart's CartItem and the
// catering draft's pending-items cart. Owns no data — callers wire qty + the
// three callbacks to whatever data layer they manage.
function QuantityStepper({
  quantity,
  onIncrement,
  onDecrement,
  onRemove,
  adjustPadding = false,
}: QuantityStepperProps) {
  const Wrapper = adjustPadding ? CartIconWrapper : IconWrapper;

  return (
    <Wrapper data-testid="cart-item-edit-quantity">
      <StepperWrapper>
        {quantity > 1 ? (
          <StepperIconWrapper data-testid="decrement-qty" onClick={onDecrement}>
            <Icon size={Icon.Sizes.Medium} type={Icon.Types.Subtract} />
          </StepperIconWrapper>
        ) : (
          <StepperIconWrapper data-testid="decrement-qty" onClick={onRemove}>
            <Icon size={Icon.Sizes.Medium} type={Icon.Types.TrashLine} />
          </StepperIconWrapper>
        )}
        <Text data-testid="cart-item-qty-amount" styles={Text.Styles.Bold14}>
          {quantity}
        </Text>
        <StepperIconWrapper data-testid="increment-qty" onClick={onIncrement}>
          <Icon size={Icon.Sizes.Medium} type={Icon.Types.Add} />
        </StepperIconWrapper>
      </StepperWrapper>
    </Wrapper>
  );
}

export default QuantityStepper;
